export default {
  key: 'system--canvas',
  routes: [
    /^\/dashboard$/,
    /^\/profile$/,
    /^\/studio$/,
    /^\/[^/]+\/[^/]+/,
  ],
  i18nNamespaces: ['canvas'],
  app:     () => import('./app.js').then(m => m.default),
  context: () => import('./context.js').then(m => m.default),
  fetchOnMount: ({ state, sdk, params }) => {
    if (params?.owner && params?.project) {
      return sdk.project.getProjectByKey({ owner: params.owner, key: params.project })
        .then(p => { state.project = p })
    }
  },
  onParamsChange: ({ newParams, oldParams, state, sdk }) => {
    if (newParams?.project !== oldParams?.project && newParams?.owner && newParams?.project) {
      state.project = null
      state.projectComponents = null
      state.projectPages = null
      state.projectState = null
      return sdk.project.getProjectByKey({ owner: newParams.owner, key: newParams.project })
        .then(p => { state.project = p })
    }
  },
}
